import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { upsertMultipleDepots } from '../depotsSlice'
import { Depot } from '../models/Depot'

export const fetchDepots = createAsyncThunk('depots/fetchDepots', async (_, { dispatch }) => {
  const depots = await OLMSApiService.get<Depot[]>('/depot/list')

  if (depots && depots.length > 0) {
    dispatch(upsertMultipleDepots(depots))
  }
})